import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import OrderHeader from './OrderHeader';
import Header from './Header';
import styles from './styles.module.scss';

const CollapsibleBar = ({
  openOnLoad,
  header,
  title,
  isDesktop,
  headerClickable,
  onClickOrderHeader,
  trackOrderViewed,
  children,
}) => {
  const [isOpen, setIsOpen] = useState(openOnLoad);
  const handleToggleOpen = () => {
    if (!isOpen) {
      if (trackOrderViewed) trackOrderViewed();
    }
    setIsOpen((prevState) => !prevState);
  };

  return (
    <div
      className={cx(styles['collapsible-bar-container'], { [styles['is-open']]: isOpen })}
      data-testid="collapsible-bar-container"
    >
      {title && (
        <Header title={title} headerClickable={headerClickable} toggleOpen={handleToggleOpen} />
      )}
      {header && (
        <OrderHeader
          isDesktop={isDesktop}
          saleType={header.saleType}
          billingDate={header.billingDate}
          items={header.items}
          orderTotal={header.orderTotal}
          shippingAddress={header.shippingAddress}
          onClickHeader={onClickOrderHeader}
          toggleOpen={handleToggleOpen}
        />
      )}
      <div className={styles.content} data-testid="collapsible-bar-content">
        {children}
      </div>
    </div>
  );
};

CollapsibleBar.propTypes = {
  openOnLoad: PropTypes.bool,
  header: PropTypes.shape({}),
  title: PropTypes.string,
  isDesktop: PropTypes.bool,
  headerClickable: PropTypes.bool,
  onClickOrderHeader: PropTypes.func,
  trackOrderViewed: PropTypes.func,
  children: PropTypes.node.isRequired,
};

CollapsibleBar.defaultProps = {
  openOnLoad: false,
  header: null,
  title: null,
  isDesktop: false,
  headerClickable: false,
  onClickOrderHeader: () => {},
  trackOrderViewed: () => {},
};

export default CollapsibleBar;
